import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft, ShieldCheck } from "lucide-react";
import { API_BASE_URL } from "../config";
import vrmLogo from "../assets/VRM_New.jpeg";

function BuyerForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email.trim()) {
      setError("Please enter your registered email address.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/buyer/auth/forgot-password`,
        { email: email.trim() }
      );
      setMessage(
        res.data.message ||
        "If an eligible account exists for that email, a reset link will be sent."
      );
    } catch (err) {
      setError("Unable to process your request. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", fontFamily: "Inter, sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: "16px", padding: "40px", width: "100%", maxWidth: "420px", boxShadow: "0 25px 50px -12px rgba(0,0,0,.3)", boxSizing: "border-box" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img src={vrmLogo} alt="VRM AI Logo" style={{ height: "64px", marginBottom: "12px", mixBlendMode: "darken" }} />
          <h2 style={{ margin: "0 0 8px", color: "#0f172a", fontSize: "22px" }}>VRM AI TECHNOLOGY</h2>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#eef2ff", color: "#4f46e5", padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: 600 }}>
            <ShieldCheck size={14} /> Buyer Portal
          </div>
        </div>

        <h3 style={{ color: "#0f172a", marginBottom: "8px" }}>Forgot Password?</h3>
        <p style={{ color: "#64748b", fontSize: "14px", lineHeight: 1.6, marginBottom: "24px" }}>
          Enter your registered email address. If your account is eligible, we’ll send you a secure password-reset link.
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="reset-email" style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#475569", marginBottom: "6px" }}>Registered Email</label>
          <div style={{ position: "relative", marginBottom: "18px" }}>
            <Mail size={18} style={{ position: "absolute", left: "14px", top: "12px", color: "#94a3b8" }} />
            <input id="reset-email" type="email" required autoComplete="email" placeholder="name@company.com" value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: "100%", padding: "10px 14px 10px 42px", borderRadius: "8px", border: "1px solid #cbd5e1", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
          </div>

          {error && <div role="alert" style={{ background: "#fef2f2", color: "#991b1b", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "18px" }}>{error}</div>}
          {message && <div role="status" style={{ background: "#ecfdf5", color: "#065f46", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", lineHeight: 1.5, marginBottom: "18px" }}>{message}</div>}

          <button type="submit" disabled={loading} style={{ width: "100%", padding: "12px", background: "#4f46e5", color: "#fff", border: "none", borderRadius: "8px", fontWeight: 600, fontSize: "15px", cursor: loading ? "not-allowed" : "pointer" }}>
            {loading ? "Sending request…" : "Send Reset Link"}
          </button>
        </form>

        <div style={{ marginTop: "24px", textAlign: "center" }}>
          <Link to="/buyer/login" style={{ color: "#4f46e5", textDecoration: "none", fontSize: "13px", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: "6px" }}>
            <ArrowLeft size={15} /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BuyerForgotPassword;
